module.exports = __webpack_public_path__ + "img/CB0010_bear.45c5d10e.png";